import { object, string } from 'yup';
const formSpec = {
    email: string()
        .required('This field is required')
        .email('Please enter a valid email address'),
};
export const forgotPasswordSchema = object(formSpec);
